import { render } from "./PpcBudgetAllocationWeeklyBudgetEdit.vue?vue&type=template&id=5cba4012&scoped=true"
import script from "./PpcBudgetAllocationWeeklyBudgetEdit.vue?vue&type=script&lang=js"
export * from "./PpcBudgetAllocationWeeklyBudgetEdit.vue?vue&type=script&lang=js"

import "./PpcBudgetAllocationWeeklyBudgetEdit.vue?vue&type=style&index=0&id=5cba4012&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cba4012"]])

export default __exports__